import React from "react";
import { Button } from "@material-ui/core";

interface IExtensionButtonProps {}

const ExtensionButton: React.FC<IExtensionButtonProps> = () => {
  const handleClick = () => {
    window.open(
      "https://chrome.google.com/webstore/detail/faktual/cmnkamoefcblfmmadghlkgdgbmoigfag?hl=de"
    );
  };
  return (
    <Button
      onClick={handleClick}
      color="primary"
      variant="contained"
      size="small"
    >
      Install
    </Button>
  );
};

export default ExtensionButton;
